import { FC, PropsWithChildren } from 'react';

const TableTr: FC<PropsWithChildren<{ 
  onClick?: () => unknown,
  className?: string,
}>> = ({
  onClick,
  className,
  children,
}) => (
  <tr 
    className={`
      ${onClick ? 'hover:bg-gray-100' : 'hover:bg-gray-50'}
      ${className || ''}
    `}
    {...(onClick
      ? {
        tabIndex: -1,
        role: 'button',
        onClick,
      } : {}
    )}
  >
    {children}                           
  </tr>
);

export default TableTr;
